export const phoneMask = '+1(999)999-9999'
export const
    websitePattern = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/


// WEBPACK FOOTER //
// ./util/consts.js